<template>
    <div id="input" :style="{ width: inputSize }">
        <div class="title">
            <label>{{ title }}</label>
        </div>
        <div class="input-container" tabindex="0">
            <input v-if="inputMask" :type="type" v-mask="inputMask" :placeholder="placeHolder" v-model="cloneValue" />
            <input v-else :type="type" :placeholder="placeHolder" v-model="cloneValue" />
        </div>
    </div>
</template>
<script>
export default {
    name: "Input",
    props: {
        value: {
            type: String,
            default: null,
        },
        placeHolder: {
            type: String,
            default: "",
            required: false,
        },
        title: {
            type: String,
            required: false,
        },
        isPaymentTypeForm: {
            type: Boolean,
            required: false,
            default: false,
        },
        size: {
            type: String,
            required: false,
            default: "large",
            validator(value) {
                return ["large", "medium", "small"].includes(value);
            },
        },
        type: {
            type: String,
            default: "text",
            required: false,
            validator(value) {
                return ["text", "number", "password", "submit"].includes(value);
            },
        },
        mask: {
            type: String,
            validator(value) {
                return ["phoneNumber", "creditCard", "skt", "cvv"].includes(value);
            },
        },
        color: {
            type: String,
            default: "#707070",
        },
    },
    data() {
        return {
            inputSize: "100%",
            inputMask: false,
            cloneValue: this.value,
        };
    },
    watch: {
        cloneValue(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.$emit("input", newVal);
            }
        },
        value(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.cloneValue = newVal;
            }
        },
    },
    methods: {
        inputChangeHandler() {},
        inputSizeControl(value) {
            switch (value) {
                case "large":
                    this.inputSize = "100%";
                    break;
                case "medium":
                    this.inputSize = "50%";
                    break;
                case "small":
                    this.inputSize = "25%";
                    break;
                default:
                    break;
            }
        },
        inputMaskValidator(value) {
            switch (value) {
                case "phoneNumber":
                    this.inputMask = "(###) ### ## ##";
                    break;
                case "creditCard":
                    this.inputMask = "#### #### #### ####";
                    break;
                case "skt":
                    this.inputMask = "##/##";
                    break;
                case "cvv":
                    this.inputMask = "###";
                    break;
                default:
                    break;
            }
        },
    },
    mounted() {
        if (this.size) {
            this.inputSizeControl(this.size);
        }
        if (this.mask) {
            this.inputMaskValidator(this.mask);
        }
    },
};
</script>
<style lang="scss">
#input {
    width: 100%;
    background-color: transparent;
    margin-bottom: 25px;

    .title {
        label {
            color: #536777;
            font-size: 19px;
        }
    }

    .ant-select-selection {
        border: none !important;
        background: none !important;
    }

    .ant-input {
        &.ant-select-search__field {
            border: 1px solid #a5a5a5;
            border-radius: 5px;
            height: 37px;
            padding: 0;
            padding-left: 10px;
            overflow: hidden;
        }
    }

    .input-container {
        border: 1px solid #a5a5a5;
        border-radius: 5px;
        height: 56px;
        padding: 0;
        padding-left: 10px;
        overflow: hidden;

        &:focus-within {
            border-color: #ec4b1d;
        }

        input {
            width: 100%;
            height: 100%;
            border: none;
            font-size: 19px;
            color: black;

            &:-webkit-autofill,
            -webkit-autofill-selected,
            -webkit-internal-autofill-selected {
                -webkit-box-shadow: 0 0 0px 1000px #fff;
                background-color: #fff !important;
            }
        }
    }
}
</style>
